import { render, staticRenderFns } from "./KalenderVeranstaltung.vue?vue&type=template&id=f8df532e&scoped=true"
import script from "./KalenderVeranstaltung.vue?vue&type=script&lang=js"
export * from "./KalenderVeranstaltung.vue?vue&type=script&lang=js"
import style0 from "./KalenderVeranstaltung.vue?vue&type=style&index=0&id=f8df532e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8df532e",
  null
  
)

export default component.exports